import { render, staticRenderFns } from "./backPackDetail.vue?vue&type=template&id=2f77808e&"
import script from "./backPackDetail.vue?vue&type=script&lang=js&"
export * from "./backPackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f77808e')) {
      api.createRecord('2f77808e', component.options)
    } else {
      api.reload('2f77808e', component.options)
    }
    module.hot.accept("./backPackDetail.vue?vue&type=template&id=2f77808e&", function () {
      api.rerender('2f77808e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/backPackDetail.vue"
export default component.exports